module.exports = __webpack_public_path__ + "static/Forager10-30d602a47cee09f8ecb1ecc236c074a2.webp";